import { PROFILE_TEXT_MAX_LENGTH } from "./profileText";

const DISALLOWED_PROFILE_NAME_CHARACTERS = /[^\p{L}\p{M}\s.'’-]/gu;

export function sanitizeProfileDisplayNameInput(value, max = PROFILE_TEXT_MAX_LENGTH) {
  const cleaned = String(value ?? "").replace(DISALLOWED_PROFILE_NAME_CHARACTERS, "");
  if (!Number.isFinite(max) || max <= 0) return "";
  return cleaned.slice(0, max);
}

export function normalizeProfileDisplayName(value, max = PROFILE_TEXT_MAX_LENGTH) {
  return sanitizeProfileDisplayNameInput(value, max).replace(/\s+/g, " ").trim();
}
